import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
export default Vue.extend({
    computed: Object.assign(Object.assign({}, mapGetters('system_configuration', [
        'activeSystemRendering',
        'activeSystemName',
        'activeSystemSubname',
    ])), mapState('system_configuration', ['application'])),
});
